"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currency_js_1 = __importDefault(require("currency.js"));
const currencyOptionDefaults = {
    precision: 4,
};
const currency = (val, options) => {
    let passedOptions = {};
    if (typeof options !== 'undefined') {
        passedOptions = options;
    }
    const initOptions = {
        ...currencyOptionDefaults,
        ...passedOptions,
    };
    const result = (0, currency_js_1.default)(val, initOptions);
    result.format = (overrideOptions) => (0, currency_js_1.default)(result.value, {
        ...initOptions,
        precision: 2,
        ...overrideOptions,
    }).format();
    return result;
};
exports.default = currency;
//# sourceMappingURL=index.js.map